module.exports = __webpack_public_path__ + "img/loadinggif.e003a706.gif";